import * as PunchListActionType from './constants';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 10,
  sort: { field: 'refNo', order: 'descending' },
  status: 'all',
  totalRecord: 0,
  totalPage: 0
};

const ManagePunchList = {
  items: [],
  params: defaultParams
};

const PunchListState = {
  WorkOrderAttachments: [],
  ManagePunchList: ManagePunchList,
  PunchListProfile: null,
  PunchListItemProfile: null,
  AWSCredentials: null
};

export default function PunchListStore(state = PunchListState, action) {
  switch (action.type) {
    case PunchListActionType.SEARCH_SUBCONTRACTOR_PUNCH_LIST_SUCCESS:
    case PunchListActionType.SEARCH_PUNCH_LIST_SUCCESS:
      var result = action.data;
      var managePunchList = {
        items: result.data.items,
        params: {
          totalRecord: result.data.totalRecord,
          totalPage: result.data.totalPage,
          skip: result.params.skip + 1,
          take: result.params.take,
          status: result.params.status,
          name: result.params.name,
          sort: {
            field: result.params.sortField,
            order: result.params.sortOrder
          }
        }
      };
      return {
        ...state,
        ManagePunchList: managePunchList
      };

    case PunchListActionType.GET_PUNCH_LIST_DETAIL_SUCCESS:
      return {
        ...state,
        PunchListProfile: action.data 
      };

    // case PunchListActionType.GET_PUNCH_LIST_DETAIL_ASYNC:
    case PunchListActionType.GET_PUNCH_LIST_DETAIL_FAIL:
      return {
        ...state,
        PunchListProfile: null
      };
    case PunchListActionType.RESET_PUNCH_LIST:
      return {
        ...state,
        ManagePunchList: ManagePunchList,
        PunchListProfile: null
      };
    case PunchListActionType.GET_PUNCH_LIST_ITEM_DETAIL_SUCCESS:
      var punchItemProfile = {
        ...action.data,
        workOrder: {
          woInformation: action.data.workOrder
        },
        WorkOrderCommentList: []
      };
      if (action.data.requestDetail) {
        punchItemProfile['requestDetail'] = action.data.requestDetail;
      }
      return {
        ...state,
        PunchListItemProfile: punchItemProfile,
        WorkOrderAttachments: action.data.workOrder.attachments
          ? action.data.workOrder.attachments
          : []
      };
    case PunchListActionType.RESET_PUNCH_LIST_ITEM:
      return {
        ...state,
        PunchListItemProfile: null
      };
    case PunchListActionType.UPDATE_PUNCH_ITEM_SUCCESS:
      return {
        ...state,
        PunchListItemProfile: {
          ...state.PunchListItemProfile,
          workOrder: {
            woInformation: action.data
          }
        }
      };
    case PunchListActionType.SETUP_PUNCH_LIST_AWS_SUCCESS:
      return {
        ...state,
        AWSCredentials: action.data
      };
      //  case PunchListActionType.CREATE_PUNCH_LIST_ASYNC:
      //   return {
      //     ...state,
          // params: {
          //   isPunchList: true,
          //   lotId: "38d1837a3e3f44b9809efa4acd18b850",
          //   managedByUserId: "59fefbc3-15a9-4a87-ada1-d310c1604873",
          //   projectId: "bef42415f2454ff795b001d68b681ea7",
          //   requestTypeId: "eb4a83dd2a8e4d86ab808f0bcfca6532"
          // }
          // PunchListProfile: action.data

          // request: action.params,
          // Loading: { ...state.Loading, loading: true }
        // };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Punch-List/reducers.js